import { ComponentProps } from 'react';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { lazy } from 'utils/generic/lazy';
import { ESportsbookPageTypes } from 'interfaces/sportsbook-configs';
import './index.less';
import '../index.less';

type Props = ComponentProps<typeof RocketBetComponent> & {
  pageType: ESportsbookPageTypes;
  isAllCollapsed: boolean | undefined;
};

const { RocketBetComponent } = lazy(
  () => import(/* webpackChunkName: "rocketbet" */ './Component')
);

export const RocketBet = (props: Props) => {
  return SpringConfigs.ROCKET_BET &&
    props.pageType !== ESportsbookPageTypes.esport ? (
    <RocketBetComponent
      key={`${props.gameId}-${props.game.team1_name}`}
      game={props.game}
      currentSport={props.currentSport}
      gameId={props.gameId}
      competitionName={props.competitionName}
      isAllCollapsed={props.isAllCollapsed}
    />
  ) : null;
};
